import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const deleteSecurityGroupOperation = async (
  groupId: number,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.deleteSecurityGroup(groupId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('קבוצת ההרשאות נמחקה בהצלחה');
    onSuccess();
  } catch (error) {
    console.error('deleteSecurityGroupOperation failed:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
